<template>
  
    <div id="plotarea">
        <div id="tooltip-elevation">
            <div>
                <i class='fa-w vtl vtl-distance'></i>  <b>{{currentDist}} km</b>
            </div>
            <div>
                 <i class='fa-w vtl vtl-altimetria'></i> <b> {{currentElevation}} km</b>
            </div>
        </div>
        <svg ref="profile" width='100%' height='100%'> </svg>     
    </div>

</template>


<script>

import lineDistance from '@turf/length'
// import * as d3 from 'd3'

import { line, curve, curveCatmullRom, area } from "d3-shape";
import { scaleTime, scaleLinear } from "d3-scale";
import { axisBottom, axisLeft } from 'd3-axis';
// import { timeParse, isoFormat } from "d3-time-format";
import { select } from "d3-selection";
import { extent, max, min } from "d3-array";
import {interpolateRgb} from "d3-interpolate";
import { TweenMax } from "gsap";

var d3 = {
    line: line,
    scaleTime: scaleTime,
    scaleLinear: scaleLinear,
    axisBottom: axisBottom,
    axisLeft: axisLeft,
    // timeParse: timeParse,
    // isoFormat: isoFormat,
    select: select,
    extent: extent,
    min: min,
    max: max,
    area,
    interpolateRgb: interpolateRgb,
};




export default {

    data:function(){
        return{
            currentDist:0,
            currentElevation:0,
           
        }
    },


    props:{
        geoJSON:{
            default:false
        },
        showAxis:{
             default:false
        },
        metersInMeters:{
            default:500
        },
        steps:{
            default:8
        },
        delay:{
            default:0 //seconds
        },
        duration:{
            default:2 //seconds
        },
        startedDistance:{
            default:0
        },
    },


     computed:{
        terrainProfile:function(){
            if(!this.geoJSON) return false;
            var course = this.geoJSON;
            var distance = lineDistance(course);
            var points = [];

            var meters = distance/this.steps;
            

            for (var i = 0; i < distance; i += meters) {
                var point = _.along(course, i);
                point.properties['distancia'] = i;
                var slope = _.get(point, 'properties.slope');
                point.properties['color'] = _.colorRamp(-7, 5, slope);
                points.push(point);
            }
            return points
        },

        
        stats:function(){
            return _.courseStats(this.geoJSON);
        },

        maxElevation:function(){
            return this.stats.max_alt;
        },

        minElevation:function(){
            return this.stats.min_alt;
        },

        terrainProfileData:function(){
            var profileData = []
            
            _.each(this.terrainProfile, (v,index)=> {
                if(_.hasIn(v, 'properties.distancia') && _.hasIn(v, 'properties.altitude')){
                    
                    
                    var data = {'x':v.properties.distancia, 
                            'y':v.properties.altitude, 
                            'yvisual':v.properties.altitude, 
                            'slope': v.properties.slope, 
                            'color':v.properties.color
                    }
                     profileData.push(data)
                }
            });
            return  profileData;                
        }
    },

    watch:{
        terrainProfile: function(){
                this.plot();
        },
        steps:function(){
              this.plot();
        },
    },

    mounted: function(){
        this.$nextTick( ()=>{

                setTimeout(()=>{
                   this.plot();
                },this.delay*1000)
        })
        $(window).resize(()=>{this.plot()});
    },


    methods:{

        plot:function(){

            var _this = this;

            //remove any existing bars
            if (this.svgContent)
                this.svgContent.remove();

            if ( _.isEmpty(this.terrainProfile) )
                return false

            var father = $('#plotarea svg')[0];
            var svg = d3.select(this.$refs.profile);

            var margin = {
                top: 20,
                right: 0,
                bottom: 30,
                left: 0
            };

            var width = father.clientWidth - margin.left - margin.right;
            var height = father.clientHeight - margin.top - margin.bottom;

            var tooltip = d3.select("#tooltip-elevation").style("opacity", 0);

            var g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            this.svgContent = g;

         

            var graphicBottom = d3.min(this.terrainProfileData, function (d) {
                return d.y;
            });
          
            var graphicUp = d3.max(this.terrainProfileData, function (d) {
                return d.y;
            });
          
            var y = d3.scaleLinear().range([height/4, 0]).domain([graphicBottom, graphicUp]);
            var y2 = d3.scaleLinear().range([height, 0]).domain([graphicBottom, graphicUp]);

            var x = d3.scaleLinear().rangeRound([0, width]);
            
            
            var interpolateColor = d3.interpolateRgb("blue", "gray", "red");
             var slopeInterpolate = d3.scaleLinear().range(0,1).domain([-5, 5]);

            x.domain(d3.extent(this.terrainProfileData, function (d) {
                return d.x;
            }));

            

            var def = svg.append("defs")
            var len = this.terrainProfileData.length;

            for (var i = 1; i < len; i++) {
                var data = [this.terrainProfileData[i - 1], this.terrainProfileData[i]];
             
                var area = d3.area()
                    .x(function (d) {
                        return x(d.x);
                    })
                    .y1(function (d) {
                        return y(d.y);
                    });

                area.y0( y2(graphicBottom) );

                g.append("path")
                    .datum(data)
                    .attr("d", area)
                    .attr("fill", "url(#gradient" + i + ")")
                    .style("opacity", 0)
                    .attr("class", "grafbar")
                    .on("mouseover", (d)=> {
                        this.currentDist = d[0].x.toFixed(1);
                        this.currentElevation = d[0].y.toFixed(1);
                        tooltip.transition()
                            .duration(50)
                            .style("opacity", .9);
                        tooltip.style("left", (d3.event.pageX) + "px")
                            .style("top", (d3.event.pageY - 28) + "px");

                        window.UIEvents.$emit("elevationHover",{distance:d[0].x+this.startedDistance,elevation:d[0].y})
                    })
                    .on("mouseout", (d)=> {
                        
                        window.UIEvents.$emit("elevationOut")
                        tooltip.transition()
                            .duration(50)
                            .style("opacity", 0);

                    });

                def.append("linearGradient")
                    .attr("id", "gradient" + i)
                    .attr("x1", 0).attr("y1", '100%')
                    .attr("x2", 0).attr("y2", '0%')
                    .selectAll("stop")
                    .data([{
                            offset: "0%",
                            color: "gray"
                        },
                        // {
                        //     offset: "50%",
                        //     color: "gray"
                        // },
                        {
                            offset: "90%",
                            color:  data[0].color //interpolateColor(slopeInterpolate(data[0].slope)) // data[0].color
                        }
                    ])
                    .enter().append("stop")
                    .attr("offset", function (d) {
                        return d.offset;
                    })
                    .attr("stop-color", function (d) {
                        return d.color;
                    });
            }

            var xAxis = d3.axisBottom(x);

            g.append("g")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxis);

            var yAxis = d3.axisLeft(y).ticks(2);

            if(this.showAxis){
                g.append("g")
                    .call(yAxis)
                    .append("text")
                    .attr("fill", "#FFFFFF")
                    .attr("transform", "rotate(-90)")
                    .attr("y", 6)
                    .attr("dy", "0.71em")
                    .attr("text-anchor", "end");
            }


            //animate the graph
            var totalBars = $(".grafbar").length;
            var animationTime =  this.duration

            this.started = true

            TweenMax.staggerTo(".grafbar", animationTime / totalBars, {
                autoAlpha: 1,
                delay:0,
                ease: Power3.easeIn
            }, animationTime / totalBars)
                }

        },


    }

            
</script>



<style lang="stylus" >
    @import "../css/variaveis";

    #plotarea{
        width 100%;
        height:100%;
        // background:rgba(white,0.2);
        overflow hidden;
    }

    #tooltip-elevation{
        padding:5px 8px;
        background:rgba(black,0.5);
        border-radius 3px;
        font-size:10px;
        color:white;
        line-height 0.9;
        position:fixed;
        z-index:100;
        transform:translateX(-50%);
        margin-top:-20px;
        min-width 90px;

    }

    #plotarea text{
        fill:white !important;
    }

    
</style>